"use client";

import React, { createContext, useContext } from "react";
import type { ComposeClientContextValue } from "@/lib/core/crm/types";

const ComposeClientContext = createContext<ComposeClientContextValue | null>(null);

interface ComposeClientProviderProps {
  children: React.ReactNode;
  value: ComposeClientContextValue;
}

export function ComposeClientProvider({
  children,
  value,
}: ComposeClientProviderProps) {
  return (
    <ComposeClientContext.Provider value={value}>
      {children}
    </ComposeClientContext.Provider>
  );
}

export function useComposeClientContext() {
  const context = useContext(ComposeClientContext);
  if (!context) {
    throw new Error("useComposeClientContext must be used within a ComposeClientProvider");
  }
  return context;
}
